module.exports = __webpack_public_path__ + "h5/img/aroma.8717d84a.jpg";